import { Alert, Collapse } from "@mui/material";
import { selectOperation } from "@redux/features/dfs/dfsSlice";
import { performIntegrationExport } from "@redux/features/dfs/thunks";
import { isDataTransferStateActive } from "@redux/features/dfs/types";
import { useExportDataToSusoftMutation } from "@redux/features/integrations/susoftApi";
import { useAppDispatch, useAppSelector } from "@redux/hooks";
import BaseButton from "@reusables/BaseButton";
import BaseModal from "@reusables/Modals/BaseModal";
import { useTranslation } from "react-i18next";

interface SusoftExportModalProps {
    isOpen: boolean;
    onClose: () => void;
}

export default function SusoftExportModal({ isOpen, onClose }: SusoftExportModalProps) {
    const { t } = useTranslation("", {
        keyPrefix: "exports.modules.susoft.exportModal",
    });

    const dispatch = useAppDispatch();

    const [exportToSusoft, { isLoading: isExportLoading }] = useExportDataToSusoftMutation();

    const isExportInProgress = useAppSelector((state) =>
        isDataTransferStateActive(selectOperation("export")(state))
    );

    const handleExport = () => {
        dispatch(
            performIntegrationExport("susoft", () => {
                return exportToSusoft({
                    entities: ["product"],
                }).unwrap();
            })
        );

        onClose();
    };

    return (
        <BaseModal
            isOpen={isOpen}
            onClose={onClose}
            width={800}
            padding="45px"
            useCloseIcon
            isLoading={isExportLoading}
        >
            <div className="space-y-[32px]">
                <div className="text-xl font-semibold text-center text-accent">{t("heading")}</div>

                <Collapse in={isExportInProgress} unmountOnExit mountOnEnter>
                    <Alert severity={"warning"}>{t("exportIsAlreadyInProgressAlert")}</Alert>
                </Collapse>

                <div className="text-center text-accent">{t("description")}</div>

                <div className="grid grid-cols-2 gap-[16px]">
                    <BaseButton
                        buttonWidth="100%"
                        text={t("buttons.cancel")}
                        size="md"
                        primaryOutlined
                        onClick={onClose}
                    />
                    <BaseButton
                        buttonWidth="100%"
                        text={t("buttons.export")}
                        size="md"
                        onClick={handleExport}
                        loading={isExportInProgress}
                    />
                </div>
            </div>
        </BaseModal>
    );
}
